module.exports = __webpack_public_path__ + "media/Video 145a.c7fbde2d.mp4";